// 2026-05-26 - FormuLearning - 인증 상태 관리 (Zustand)
// 2026-11-03 수정 - 이슈 #114: 역할을 `lib/readOnly` 에 알린다(인터셉터·지연 저장이 React 밖에서 viewer 를 판정).
// 파일 위치: frontend/src/stores/authStore.ts

import { create } from 'zustand'
import type { User } from '../types/auth'
import * as authApi from '../api/auth'
import { setReadOnlyRole } from '../lib/readOnly'

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  checkAuth: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: !!localStorage.getItem('access_token'),
  isLoading: false,

  login: async (email, password) => {
    const result = await authApi.login({ email, password })
    localStorage.setItem('access_token', result.access_token)
    setReadOnlyRole(result.user.role)
    set({ user: result.user, isAuthenticated: true })
  },

  logout: async () => {
    await authApi.logout()
    localStorage.removeItem('access_token')
    setReadOnlyRole(null)
    set({ user: null, isAuthenticated: false })
  },

  checkAuth: async () => {
    if (!localStorage.getItem('access_token')) {
      set({ isAuthenticated: false, user: null })
      return
    }
    set({ isLoading: true })
    try {
      const user = await authApi.getMe()
      setReadOnlyRole(user.role)
      set({ user, isAuthenticated: true, isLoading: false })
    } catch {
      localStorage.removeItem('access_token')
      set({ user: null, isAuthenticated: false, isLoading: false })
    }
  },
}))
